define([], function () {
    var framework = {
        "clientIpInvalid.helpUrl": "/es-us/usermanual-iam/iam_07_0003.html",
    };

    function i18n(key) {
        return i18n.framework[key];
    };
    i18n.framework = framework;
    return i18n;
})


// WEBPACK FOOTER //
// ./public/hws/i18n/es-us/resourcehk.js